const ReportsPages = () => {

    return (
        <>
            <h1>Report Pages</h1>
        </>
    )
}
export default ReportsPages;
